var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7454 12.3624H13.4183L17.6685 16.6211L16.3994 17.8902L12.1407 13.64V12.9671L11.9107 12.7286C10.9397 13.5633 9.67913 14.0658 8.30782 14.0658C5.25006 14.0658 2.77148 11.5873 2.77148 8.5295C2.77148 5.47174 5.25006 2.99316 8.30782 2.99316C11.3656 2.99316 13.8442 5.47174 13.8442 8.5295C13.8442 9.90081 13.3416 11.1614 12.5069 12.1324L12.7454 12.3624ZM4.47494 8.5295C4.47494 10.6503 6.18695 12.3624 8.30779 12.3624C10.4286 12.3624 12.1406 10.6503 12.1406 8.5295C12.1406 6.40866 10.4286 4.69665 8.30779 4.69665C6.18695 4.69665 4.47494 6.40866 4.47494 8.5295Z",
    fill: "#1034A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.4ff13a8fe5cc1c54d9c6fb68b1b5946c.svg";
export { ForwardRef as ReactComponent };